export const smartTvs = [
    {
        img: "https://i03.appmifile.com/251_item_in/15/05/2023/a1e6adb1ce20aea70a6240f16f82fac8!348x348.jpg?f=webp",
        discount: 44,
        name: "Redmi Smart TV ",
        price:"13,999"
    },
    {
        img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1622467015.57671049!348x348.jpg?f=webp",
        discount: 36,
        name: "Mi TV 4A 40 Horizon",
        price:"18,999"
    },{
        img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1663152565.22081554!348x348.jpg?f=webp",
        discount: 44,
        name: "Xiaomi Smart TV 5A",
        price:"13,999"
    },
    {
        img: "https://i03.appmifile.com/251_item_in/15/05/2023/a1e6adb1ce20aea70a6240f16f82fac8!348x348.jpg?f=webp",
        discount: 44,
        name: "Redmi Smart TV 32",
        price:"13,999"
    },
    {
        img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1622467015.57671049!348x348.jpg?f=webp",
        discount: 36,
        name: "Mi TV 4A 40 Horizon",
        price:"18,999"
    },{
        img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1681292448.74477327!348x348.jpg?f=webp",
        discount: 34,
        name: "Xiaomi Smart TV X Pro",
        price:"32,999"
    },
    {
        img: "https://i03.appmifile.com/251_item_in/15/05/2023/a1e6adb1ce20aea70a6240f16f82fac8!348x348.jpg?f=webp",
        discount: 44,
        name: "Redmi Smart TV",
        price:"13,999"
    },
    {
        img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1622467015.57671049!348x348.jpg?f=webp",
        discount: 36,
        name: "Mi TV 4A 40 Horizon",
        price:"18,999"
    },{
        img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1663152565.22081554!348x348.jpg?f=webp",
        discount: 44,
        name: "Xiaomi Smart TV",
        price:"13,999"
    },
    
]

export const smaartTvCarouselData = [
    {
        img: "https://i03.appmifile.com/702_operator_in/17/08/2023/43cbbb1a12bd2be36da68e2d7aab706b.jpg?f=webp",
        para1: "Big is Back",
        name: "Xiaomi Smart TV X Series",
        para2: "",
        price: "28,999"
      },
      {
        img: "https://i03.appmifile.com/361_operator_in/17/08/2023/ae3de5a372f6d1adb8d5a6717a9792eb.jpg?f=webp",
        para1: "Designed by Xiaomi. Powered by Google",
        name: "Xiaomi Smart TV X Pro Series",
        para2: "Premium Metal Bezel-less Design",
        price: "49,999"
      },
      {
        img: "https://i03.appmifile.com/983_operator_in/23/08/2023/52d3bffec0bf6b4114d9f89e1b8b8238.jpg?f=webp",
        para1: "Snappier and Smoother",
        name: "Xiaomi Smart TV A Series",
        para2: "",
        price: "24,999"
      },
]